import { Component, OnInit, Input, Output, EventEmitter, ElementRef, AfterViewChecked } from '@angular/core';
import { UtilsService } from '../../services/utils.service';
import { Router } from '@angular/router';
import { CUSTOM } from 'src/app/app.contant';


export interface CustomDateModel {
  from: Date;
  to: Date;
}

@Component({
  selector: 'app-custom-date-selector',
  templateUrl: './custom-date-selector.component.html',
  styleUrls: ['./custom-date-selector.component.scss'],
  standalone: false
})

export class CustomDateSelectorComponent implements OnInit, AfterViewChecked {
  @Output() applyDate = new EventEmitter<any>();
  @Input() period: any = {};
  @Input() timeOption = true;
  @Input() isOneDay: boolean = false;

  customDate: CustomDateModel;
  today: Date = new Date();
  selectionCorrect: any = false;
  urlSplit: any = [];
  dateTo: Date;
  latestMonthStart: Date;
  maxDate: Date;

  minYear: number;
  maxYear: number;
  yearRange: string;
  maxDateTo: Date;

  isScatterChart: boolean = false;

  urls5: any = { 'spc': true, 'dashboard': true, 'ega': true, 'ga': true, traceability: true, 'manual-entry': true, 'qo': true, 'da': true };
  cUrls5: any = { 'spc': true, 'ega': true, 'traceability': true };
  cUrls6: any = { 'process-charts': true, 'ega-charts': true, 'dashboard': true };
  constructor(
    public utilSer: UtilsService,
    private router: Router,
    private el: ElementRef
  ) {
    this.urlSplit = this.router.url.split('/');
  }


  ngOnInit() {
    const thisInstant = +new Date();
    this.today = new Date(this.utilSer.timeStampConverter(thisInstant, false));
    this.customDate = {
      from: this.today,
      to: this.today,
    };
    this.selectionCorrect = true;
    this.isScatterChart = this.router.url.includes('scatter') || this.urlSplit.includes('scatter');
    const isGaScatterChart = this.urlSplit[6] === 'ga-scatter-chart' || this.router.url.includes('ga-scatter-chart');

    this.maxYear = this.today.getFullYear();
    this.minYear = this.maxYear - 3;
    this.yearRange = `${this.minYear}:${this.maxYear}`;

    this.latestMonthStart = new Date(this.today);
    this.latestMonthStart.setFullYear(this.minYear);

    if (!this.timeOption) {
      // this.latestMonthStart = new Date(this.utilSer.timeStampConverter(thisInstant, false));
      // this.latestMonthStart = new Date(this.latestMonthStart.setDate(this.latestMonthStart.getDate() - 7));
      this.maxDate = this.today;
      this.maxDateTo = this.today;
    } else if (this.period.code === CUSTOM && this.isOneDay) {
      this.latestMonthStart = new Date(this.utilSer.timeStampConverter(thisInstant, false));
      this.latestMonthStart = new Date(this.latestMonthStart.setDate(this.latestMonthStart.getDate() - 1));
    } else if ((this.period.code === CUSTOM || this.period.code === 'comparison-custom') && (this.period.value === 'last-15days')) {
      this.latestMonthStart = new Date(this.utilSer.timeStampConverter(thisInstant, false));
      this.latestMonthStart = new Date(this.latestMonthStart.setDate(this.latestMonthStart.getDate() - 6));
    } else if ((this.period.code === CUSTOM || this.period.code === 'comparison-custom') && (this.period.value === 'last30days')) {
      this.latestMonthStart = new Date(this.utilSer.timeStampConverter(thisInstant, false));
      this.latestMonthStart = new Date(this.latestMonthStart.setDate(this.latestMonthStart.getDate() - 90));
      // tslint:disable-next-line: max-line-length
    } else if ((this.urlSplit[6] === 'da' || this.urlSplit[5] === 'qo') && (this.period.value === CUSTOM || this.period.value === 'comparison-custom' || this.period.code === CUSTOM)) {
      this.latestMonthStart = new Date(this.today);
      this.latestMonthStart.setFullYear(this.minYear);
      this.today = new Date();
    } else if (isGaScatterChart && (this.period.value === CUSTOM || this.period.value === 'comparison-custom' || this.period.code === CUSTOM)) {
      this.latestMonthStart = new Date(this.today);
      this.latestMonthStart.setFullYear(this.minYear);
      this.today = new Date();
    } else if ((this.urls5[this.urlSplit[6]] || this.urls5[this.urlSplit[5]]) && (this.period.value === CUSTOM || this.period.value === 'comparison-custom' || this.period.code === CUSTOM)) {
      this.latestMonthStart = new Date(this.today);
      this.latestMonthStart.setFullYear(this.minYear);
      this.today = new Date(this.today.setDate(this.today.getDate() - 6));
    }
    this.dateTo = this.today;
    this.updateMaxDateTo();
  }

  ngAfterViewChecked(): void {
    this.disabledOutOfRange();
  }

  disabledOutOfRange() {
    const calendarHost = this.el.nativeElement;
    const yearElements: NodeListOf<HTMLElement> = calendarHost.querySelectorAll('.p-yearpicker-year', 'p-yearpicker span');

    if (yearElements && yearElements.length > 0) {
      yearElements.forEach((el) => {
        const yearVal = parseInt(el.innerText?.trim(), 10);

        if (!isNaN(yearVal)) {
          if (yearVal < this.minYear || yearVal > this.maxYear) {
            el.classList.add('custom-year-disabled');
            el.style.pointerEvents = 'none';
            el.style.opacity = '0.25';
            el.style.color = '#a0a0a0';
            el.style.cursor = 'not-allowed';
          } else {
            el.classList.remove('custom-year-disabled');
            el.style.pointerEvents = 'auto';
            el.style.opacity = '1';
            el.style.color = '';
            el.style.cursor = 'pointer';
          }
        }
      })
    }
  }
  customDateChange() {
    if (this.customDate.from && this.customDate.to && (+this.customDate.from <= +this.customDate.to)) {
      this.selectionCorrect = true;

      if (this.latestMonthStart && +this.customDate.from < +this.latestMonthStart) {
        this.selectionCorrect = false;
      }

      if (!this.timeOption) {
        const daysDiff = this.dayDifference(this.customDate.from, this.customDate.to);
        if (daysDiff > 7) {
          this.selectionCorrect = false;
        }
      } else {
        const threeMonthsAfterFrom = this.addMonths(new Date(this.customDate.from), 3);
        if (+this.customDate.to > +threeMonthsAfterFrom) {
          this.selectionCorrect = false;
        }
      }

      // tslint:disable-next-line: max-line-length
      if (this.cUrls5[this.urlSplit[5]] && this.cUrls6[this.urlSplit[6]]) {
        this.dateTo = this.today;
        if (+this.customDate.to > +this.dateTo) {
          this.selectionCorrect = false;
        }
      }
    } else {
      this.selectionCorrect = false;
    }
    this.updateMaxDateTo();

    // if (!this.timeOption) {
    //   const todaysDiff = this.dayDifference(this.customDate.from, this.today);
    //   let allDiff = todaysDiff;
    //   let Days = todaysDiff - 1;
    //   if (todaysDiff <= 7) {
    //     allDiff = todaysDiff - 1;
    //   } else {
    //     allDiff = 6;
    //     Days = this.dayDifference(this.customDate.from, this.customDate.to);
    //   }
    //   this.latestMonthStart = new Date(this.customDate.from);
    //   this.latestMonthStart = new Date(this.latestMonthStart.setDate(this.latestMonthStart.getDate() + allDiff));
    //   this.maxDate = new Date(this.customDate.from);
    //   if (Days >= 7) {
    //     this.selectionCorrect = false;
    //   }
    // } else {
    //   this.updateMaxDateTo();
    // }
  }

  updateMaxDateTo() {
    if (this.customDate && this.customDate.from) {
      let limitDate: Date;

      if (!this.timeOption) {
        limitDate = new Date(this.customDate.from);
        limitDate.setDate(limitDate.getDate() + 6);
      } else {
        limitDate = this.addMonths(new Date(this.customDate.from), 3);
      }
      this.maxDateTo = +limitDate > +this.today ? this.today : limitDate;

      if (this.customDate.to && +this.customDate.to > +this.maxDateTo) {
        this.customDate.to = new Date(this.maxDateTo);
      }
    }
  }

  addMonths(date: Date, months: number) {
    const result = new Date(date);
    const targetMonth = result.getMonth() + months;
    result.setMonth(targetMonth);
    return result;
  }

  applyCustomDate() {
    const converteddate: CustomDateModel = {
      from: new Date(new Date(this.utilSer.timeStampConverter(+this.customDate.from)).setSeconds(0)),
      to: new Date(new Date(this.utilSer.timeStampConverter(+this.customDate.to)).setSeconds(0)),
    };

    this.applyDate.emit(converteddate);
  }

  dayDifference(date1, date2) {
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }

}